import SupportForm from "./SupportForm";

const SupportRequest = () => {
  return (
    <div>
      {/* <PageHeader title="Support" subTitle="Send Support Message" /> */}
      <SupportForm mode="create" />
    </div>
  );
};

export default SupportRequest;
